module.exports = __webpack_public_path__ + "media/images/icons/mute_message_center-87ad15dfc80cc786c38d5514e5f2aac7.svg";